export const formatTime = (minutes) => {
    if (!minutes || isNaN(minutes)) {
        return 'N/A';
    }

    const totalMinutes = parseInt(minutes, 10);
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    let formattedTime = '';
    if (hours > 0) {
        formattedTime += `${hours} H${hours > 1 ? 's' : ''}`;
    }
    if (hours > 0 && remainingMinutes > 0) {
        formattedTime += ', ';
    }
    if (remainingMinutes > 0) {
        formattedTime += `${remainingMinutes} M${remainingMinutes > 1 ? 's' : ''}`;
    }

    return formattedTime;
};